export const languagesamples = [
    {
        "id":0,
        "chatname":"French",
        "promptsandresponses":[
            {
             "id":1,
             "prompt":"I want to learn how to speak French. Translate my questions to French. What time is it?",
             "response":"Quelle heure est-il ?"
            },
            {
                "id":2,
                "prompt":"What is your name?",
                "response":"Comment vous appelez-vous ?"
            },
            {
                "id":3,
                "prompt":"Where is the nearest bus station?",
                "response":"Où est la station de bus la plus proche ?"
            },
            {
                "id":4,
                "prompt":"When does train arrive?",
                "response":"Quand arrive le train ?"
            },
            {
                "id":5,
                "prompt":"When does train arrive?",
                "response":"Quand arrive le train ?"
            },
            {
                "id":6,
                "prompt":"Can you tell me how to get to Louvre museum?",
                "response":"Pouvez-vous me dire comment aller au musée du Louvre ?"
            },
        ]
    },
    {
        "id":1,
        "chatname":"Spanish",
        "promptsandresponses":[
            {
             "id":1,
             "prompt":"I want to learn how to speak Spanish. Translate my questions to Spanish. What time is it?",
             "response":"¿Qué hora es?"
            },
            {
                "id":2,
                "prompt":"Who is your teacher?",
                "response":"¿Quién es tu profesor?"
            },
            {
                "id":3,
                "prompt":"This is a beautiful flower.",
                "response":"Esta es una hermosa flor."
            },
            {
                "id":4,
                "prompt":"I want to go to Greece on vacation.",
                "response":"Quiero ir a Grecia de vacaciones."
            },
            {
                "id":5,
                "prompt":"Do you have any recommendation?",
                "response":"¿Tienes alguna recomendación?"
            }
        ]
    },  
    {
        "id":2,
        "chatname":"Italian",
        "promptsandresponses":[
            {
             "id":1,
             "prompt":"I want to learn how to speak Italian. Translate my questions to Italian. What time is it?",
             "response":"Che ora è?"
            },
            {
                "id":2,
                "prompt":"Who is your teacher?",
                "response":"Chi è il tuo insegnante?"
            },
            {
                "id":3,
                "prompt":"This is a beautiful flower.",
                "response":"Questa è una bellissima fiore."
            },
            {
                "id":4,
                "prompt":"I want to go to Greece on vacation.",
                "response":"Voglio andare in Grecia in vacanza."
            },
            {
                "id":5,
                "prompt":"Do you have any recommendation?",
                "response":"Hai qualche raccomandazione?"
            }
        ]
    },
    {
        "id":3,
        "chatname":"Portuguese",
        "promptsandresponses":[
            {
             "id":1,
             "prompt":"I want to learn how to speak Portuguese. Translate my questions to Portuguese. What time is it?",
             "response":"Que horas são?"
            },
            {
                "id":2,
                "prompt":"Who is your teacher?",
                "response":"Quanto tempo é? Quem é o seu professor?"
            },
            {
                "id":3,
                "prompt":"This is a beautiful flower.",
                "response":"Esta é uma flor bonita."
            },
            {
                "id":4,
                "prompt":"I want to go to Greece on vacation.",
                "response":"Eu quero ir para a Grécia de férias."
            },
            {
                "id":5,
                "prompt":"Do you have any recommendation?",
                "response":"Você tem alguma recomendação?"
            }
        ]
    },
    {
        "id":4,
        "chatname":"Chinese",
        "promptsandresponses":[
            {
             "id":1,
             "prompt":"I want to learn how to speak Chinese. Translate my questions to Chinese. What time is it?",
             "response":"现在几点了？(Xiàn zài jǐ diǎn le?)"
            },
            {
                "id":2,
                "prompt":"Who is your teacher?",
                "response":"你的老师是谁？(Nǐ de lǎo shī shì shuí?)"
            },
            {
                "id":3,
                "prompt":"This is a beautiful flower.",
                "response":"这是一朵美丽的花。(Zhè shì yī duǒ měi lì de huā.)"
            },
            {
                "id":4,
                "prompt":"I want to go to Greece on vacation.",
                "response":"我想去希腊度假。(Wǒ xiǎng qù xī lǎ dù jià.)"
            },
            {
                "id":5,
                "prompt":"Do you have any recommendation?",
                "response":"你有什么推荐吗？(Nǐ yǒu shén me tuī jiàn ma?)"
            }
        ]
    },
    {
        "id":5,
        "chatname":"English",
        "promptsandresponses":[
            {
             "id":1,
             "prompt":"Quiero aprender a hablar inglés. Traduce mis preguntas al inglés. ¿Qué hora es?",
             "response":"What time is it?"
            },
            {
                "id":2,
                "prompt":"¿Quién es tu profesor?",
                "response":"Who is your teacher?"
            },
            {
                "id":3,
                "prompt":"Esta es una hermosa flor.",
                "response":"This is a beautiful flower."
            },
            {
                "id":4,
                "prompt":"Quiero ir a Grecia de vacaciones.",
                "response":"I want to go to Greece on vacation."
            },
            {
                "id":5,
                "prompt":"¿Tienes alguna recomendación?",
                "response":"Do you have any recommendation?"
            }
        ]
    },

]